import { ContextualInfoButtonWithText } from "@/components/buttons/ContextualInfoButton";
import { Switch } from "antd";
import { forwardRef, ReactNode } from "react";
export interface SwitchWithLabelProps {
  id: string;
  label: string | ReactNode;
  description: string | ReactNode;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  warning?: string | null | ReactNode;
  showWarning?: boolean;
  disabled?: boolean;
  size?: "small" | "default";
  className?: string;
}
export const SwitchWithLabel = forwardRef<HTMLButtonElement, SwitchWithLabelProps>(({
  id,
  label,
  description,
  checked = false,
  onChange,
  warning = null,
  showWarning = false,
  disabled = false,
  size = "small",
  className = ""
}, ref) => {
  const handleChange = (checked: boolean) => {
    if (onChange && !disabled) {
      onChange(checked);
    }
  };
  return <div className={`flex flex-col first:pt-0 last:pb-0 ${className}`}>
        <div className="flex items-center justify-between p-0">
          <ContextualInfoButtonWithText id={id}>{label}</ContextualInfoButtonWithText>
          <Switch size={size} checked={checked} onChange={handleChange} disabled={disabled} ref={ref} />
        </div>

        <div className="text-xs text-gray-500" style={{
      maxWidth: "calc(100% - 32px)"
    }}>
          {description}
        </div>

        {showWarning && warning && <div role="alert" className="mt-2 rounded-md border border-red-100 bg-red-50 p-2 text-xs text-red-500">
            <span className="font-semibold">Warning: </span>
            {warning}
          </div>}
      </div>;
});